import { Component, Input } from '@angular/core';
import { Battery, BatteryStatus } from '../../data/smart-devices.interface';

@Component({
  standalone: false,
  selector: 'sbnb-device-battery-status',
  templateUrl: './device-battery-status.component.html',
  styleUrls: ['./device-battery-status.component.scss'],
})
export class DeviceBatteryStatusComponent {
  BatteryStatus = BatteryStatus;

  @Input() battery: Battery;
}
